/** 公司配置 - 核心信息与品牌定义 */

export const company = {
  name: '天津高仁科技有限公司',
  shortName: '高仁科技',
  brand: '高仁',
  slogan: '智领未来 · 创造无限可能',
  tagline: '工业智能 · 智造未来',
  founded: '2020',
  address: '天津市南开区金平路8号华创大厦5楼',
  phone: '13682135267',
  hotline: '400-880-7626',
  email: 'info@gaoren.com',
  icp: '津ICP备2026010449号-1',
  icpUrl: 'https://beian.miit.gov.cn/',
  brochurePdf: '/brochure/gaoren-2026-brochure.pdf',
}

export const companyIntro = {
  summary:
    '天津高仁科技成立于2020年，专注工业智能化领域，提供AGV、智能制造生产线、机器人系统及软件定制等全方位解决方案，产品覆盖工业软件/系统类、教育实训类、机器人定制类、AGV类、非标自动化类等。',
  vision:
    '致力于成为中国领先的工业智能化解决方案提供商，为客户创造价值，为员工创造机会，为社会创造贡献！',
  values: ['创新', '专业', '责任', '共赢'],
  memberships: ['天津市软件行业协会'],
  capabilities: [
    'MES/ERP/WMS/OA 系统定制开发',
    '工业互联网平台建设运维',
    '智能制造生产线设计与实施',
    'AGV 移动机器人定制',
    '工业机器人系统集成',
    '教学实训设备定制',
  ],
}

export const milestones = [
  { year: '2020', title: '创立元年', desc: '公司成立，确立工业智能化方向', yearLabel: '2020' },
  { year: '2021', title: '快速成长期', desc: '完成多条AGV智能生产线交付', yearLabel: '2021' },
  { year: '2022', title: '技术突破', desc: '自研工业软件平台上线，获得多项专利', yearLabel: '2022' },
  { year: '2023', title: '规模扩张', desc: '业务覆盖全国20+省份，服务客户超500家', yearLabel: '2023' },
  { year: '2024', title: '行业领航', desc: '参与多项行业标准制定，品牌影响力显著提升', yearLabel: '2024' },
  { year: '2025', title: '战略升级', desc: '发布"AI+工业"战略，打造智能化生态系统', yearLabel: '2025' },
  { year: '2026', title: '2026 新征程', desc: '持续创新，引领行业智能化转型', yearLabel: '2026' },
]

export const clientGroups = [
  {
    label: '工业企业',
    clients: [
      '比亚迪汽车',
      '长城汽车',
      '中车集团',
      '海尔集团',
      '美的集团',
    ],
  },
  {
    label: '职业院校',
    clients: ['天津职业大学', '天津现代职业技术学院', '天津机电职业技术学院'],
  },
  {
    label: '科研院所',
    clients: [
      '中国科学院自动化研究所',
      '天津大学电气学院',
      '河北工业大学',
      '北京理工大学',
    ],
  },
  {
    label: '政府单位',
    clients: ['天津滨海新区', '天津港集团', '天津滨海高新区', '西青开发区'],
  },
]

export const brochurePreviewPages = Array.from({ length: 8 }, (_, i) => ({
  page: i + 1,
  src: `/images/pdf-pages/gaoren-${String(i + 1).padStart(2, '0')}.png`,
  label: ['首页', '关于我们', '产品', '解决方案', '智能制造', '教育实训', '合作伙伴', '联系我们'][i],
}))
